const testIds = {
  root: 'content-root',
  seeMoreButton: 'content-see-more-button',
  similarTemplateItem: 'content-similar-template-item',
  moreTemplatesTitle: 'content-more-templates-title',
};

export default testIds;
